import { ErrorHandler, inject, Injectable } from '@angular/core';

import { TelemetryService } from './telemetry.service';

/**
 * ErrorHandler global : capture toute erreur non gérée (y compris celles
 * remontées par `provideBrowserGlobalErrorListeners()`) et l'envoie à la
 * télémétrie (→ Loki), tout en conservant le log console pour le debug local.
 */
@Injectable()
export class TelemetryErrorHandler implements ErrorHandler {
  private readonly telemetry = inject(TelemetryService);

  handleError(error: unknown): void {
    this.telemetry.error(error, { 'error.source': 'angular-error-handler' });
    // Conserve le comportement par défaut (visibilité en dev / console DevTools).
    console.error(error);
  }
}
